import { createHashRouter } from 'react-router-dom'
import CreateApp from '@/pages/CreateApp'

const router = createHashRouter([
  {
    path: '/',
    element: <CreateApp />,
  },
])

export default router
